import { createSlice } from "@reduxjs/toolkit";

import { IAuthState } from "@types";
import { authApi, saveTokens } from "@services";
import { jwtDecode } from "jwt-decode";

const initialState: IAuthState = {
  user: null,
  token: {
    access: null,
    refresh: null,
  },
  permissions: [],
  applications: [],
  is_one_time_password: false,
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(authApi.endpoints.logout.matchPending, (state, action) => {
        state.user = null;
        // message.success(`User has been successfully logout`);
      })
      .addMatcher(
        authApi.endpoints.login.matchFulfilled,
        (state, { payload }) => {
          try {
            // 🧩 Decode JWT access token
            const authToken = payload?.data?.token;
            const claimsToken = authToken?.claims;
            const claims: any = claimsToken ? jwtDecode(claimsToken) : {};

            // 🧠 Merge decoded role into user
            const updatedUser = {
              ...payload?.data?.user,
              role: claims?.role,
            };

            const permissions = claims?.permissions;

            // ✅ Handle one-time password vs normal verification
            if (payload?.data?.is_one_time_password) {
              state.is_one_time_password = true;
              state.token.access = authToken?.access;
            } else {
              state.is_one_time_password = false;
              state.user = updatedUser;
              state.token = payload?.data?.token;
              state.applications = updatedUser?.company?.applications || [];
              state.permissions = !permissions?.length ? ["all"] : permissions;
            }
          } catch (err: any) {
            console.error("Error decoding token:", err);
          }
        }
      )
      .addMatcher(
        authApi.endpoints.verify.matchFulfilled,
        (state, { payload }) => {
          try {
            // 🧩 Decode JWT access token
            const authToken = payload?.data?.token;
            const claimsToken = authToken?.claims;
            const claims: any = claimsToken ? jwtDecode(claimsToken) : {};

            // 🧠 Merge decoded role into user
            const updatedUser = {
              ...payload?.data?.user,
              role: claims?.role,
            };

            const permissions = claims?.permissions;

            // ✅ Handle one-time password vs normal verification
            if (payload?.data?.is_one_time_password) {
              state.is_one_time_password = true;
              state.token.access = authToken?.access;
            } else {
              state.is_one_time_password = false;
              state.user = updatedUser;
              state.token = payload?.data?.token;
              state.applications = updatedUser?.user_applications || [];
              state.permissions = !permissions?.length ? ["all"] : permissions;
            }
          } catch (err: any) {
            console.error("Error decoding token:", err);
          }
        }
      );
  },
});

export default slice.reducer;
